const GamesModule = () => import(/* webpackChunkName: "games-module" */ './views/Module.vue');
const Games = () => import(/* webpackChunkName: "games" */ './views/Games.vue');
const SharedGames = () => import(/* webpackChunkName: "shared-games" */ './views/SharedGames.vue');

const GamesRoutes = {
    path: '/',
    component: GamesModule,
    children: [
        {
            path: 'games/:type',
            name: 'games',
            component: Games
        },
        {
            path: 'shared/:type',
            name: 'shared-games',
            component: SharedGames
        },
        {
            path: 'game-detail/:type/:menu',
            name: 'game-detail',
            component: SharedGames
        }
    ],
}

export default GamesRoutes;